<script setup>
definePage({
  meta: {
    layout: 'client',
    public: true,
    unauthenticatedOnly: true,
    title: 'Write Complaint',
  },
})

/*
  The public complaint form. It keeps the bare /service-desk path because its
  legacy `?s=&l=&u=` codes are printed and in the field; the bedside chat --
  which was never launched -- moved to /service-desk/chat.

  A stale `?t=` link is redirected there by the router guard before this
  component is ever created.
*/
</script>

<template>
  <!--
    Suspense here (not just the ancestor one in layouts/client.vue) is
    required: PublicTicketForm is an async component (top-level awaits),
    and in this Vue 3.3.8 setup an async component nested a level below a
    synchronous wrapper does not get picked up correctly by an ancestor
    Suspense alone -- it must be the direct child of a Suspense boundary.
    Verified in the browser: without this local Suspense the form renders
    blank with a Suspense-internal TypeError.
  -->
  <Suspense>
    <PublicTicketForm />
  </Suspense>
</template>
